import { ChakraText } from '@equip.health/ui';

import PatientTableCellToolTip from '~/components/common/PatientTableCellToolTip';
import { getPatientListSurveyActivities } from '~/lib/util/patient.util';

const DEFAULT_VALUE = '-';

interface PatientTableSurveyActivityCellProps {
  id: string;
  surveyActivities: PatientListSurveyActivity[];
  surveyName: string;
}

const PatientTableSurveyActivityCell = ({
  id,
  surveyActivities,
  surveyName,
}: PatientTableSurveyActivityCellProps) => {
  const activitiesToDisplay = getPatientListSurveyActivities(
    surveyActivities,
    surveyName,
  );

  const value = !surveyActivities?.length
    ? DEFAULT_VALUE
    : (activitiesToDisplay['survey complete'] ??
      [
        activitiesToDisplay['survey invitation'],
        activitiesToDisplay['survey reminder'],
      ]
        .filter(Boolean)
        .join('; '));

  if (!surveyActivities?.length)
    return <ChakraText id={id}>{value}</ChakraText>;

  return (
    <PatientTableCellToolTip content={value} id={`${id}__tooltip`}>
      <ChakraText
        id={id}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {value}
      </ChakraText>
    </PatientTableCellToolTip>
  );
};

export default PatientTableSurveyActivityCell;
